import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import clsx from 'clsx';
import { IconChevronDown, IconChevronUp } from '@americanexpress/dls-icons';
import { sanitize } from '@americanexpress/consumer-travel-base';
import { usePersonaApi } from '../../apiHooks/apiHooks';
import partialRenderOnly from '../../selectors/partialRenderOnly';
import style from './Benefits.scss';
import dlsStyles from '../../styles/dls.css';
import { BenefitIconMap } from './BenefitsMap';

const Benefits = () => {
  const isPartial = useSelector(partialRenderOnly);
  const [invokeBenefits, setLoadBenefits] = useState<boolean>(isPartial);

  useEffect(() => {
    const handler = (e: CustomEvent<{ value: boolean }>) => {
      setLoadBenefits(e.detail.value);
    };
    window.addEventListener('loadBenefits', handler as EventListener);
    return () => window.removeEventListener('loadBenefits', handler as EventListener);
  }, []);

  const { data: benefits } = usePersonaApi(invokeBenefits);

  return (
    <div id="benefits" className={clsx(dlsStyles['pad-1'], dlsStyles['width-full'])}>
      {
          benefits?.map((benefit, index) => (
            <div className={clsx('accordion', dlsStyles['text-align-left'], style.accordionPanel)} key={benefit.heading}>
              <button
                key={benefit.heading}
                type="button"
                id={`panel-${index}`}
                className={clsx(dlsStyles['pad-1'], dlsStyles['width-full'], dlsStyles['text-align-left'], dlsStyles.flex, 'accordion-panel', dlsStyles['flex-align-items-center'])}
                aria-expanded="false"
              >
                <span className={style.benefitIcon}>
                  {BenefitIconMap(benefit.iconClass, false)}
                  {BenefitIconMap(benefit.iconClass, true)}
                </span>
                <h2 className={clsx(dlsStyles['body-small-bold'], dlsStyles['pad-1'])}> {benefit.heading}</h2>
                <span className={clsx(style.accordionChevrons, dlsStyles['margin-auto-l'])}>
                  <IconChevronDown size="md" />
                  <IconChevronUp size="md" />
                </span>
              </button>
              <div className={clsx(dlsStyles['accordion-content'], style.accordionBody, dlsStyles['body-small'], dlsStyles['width-full'])} aria-labelledby={`panel-${index}`} aria-hidden="true">
                {/* eslint-disable-next-line react/no-danger -- sanitized */}
                <p className={clsx(dlsStyles['pad-1'], dlsStyles['pad-3-l'])} dangerouslySetInnerHTML={{ __html: sanitize(benefit?.bodyText) }} />
              </div>
            </div>
          ))
        }
    </div>
  );
};

export default Benefits;
